/**
 * Назначение: вход платформенного контура (выбор первого экрана по правам).
 * Кто: СА и персонал платформы.
 * Вход: URL /superadmin (platform shell).
 */

import { Navigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../app/router/route-paths';
import {
  canAccessPlatformDashboard,
  canAccessPlatformOrganizationsList
} from '../../shared/access/access';
import { useAuth } from '../../shared/auth/use-auth';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shared/ui/Card';
import { Container } from '../../shared/ui/Container';
import { Stack } from '../../shared/ui/Stack';

/** `/superadmin`: редирект на сводку или каталог организаций по capabilities. */
export default function SuperadminPlatformEntryPage() {
  const cap = useAuth().me?.capabilities;

  if (canAccessPlatformDashboard(cap)) {
    return <Navigate to={ROUTE_PATHS.superadminDashboard} replace />;
  }
  if (canAccessPlatformOrganizationsList(cap)) {
    return <Navigate to={ROUTE_PATHS.superadminOrganizations} replace />;
  }

  return (
    <Container maxWidth="lg">
      <Stack gap={4}>
        <Card>
          <CardHeader>
            <CardTitle>Платформа</CardTitle>
            <CardDescription>Нет доступа к сводке или каталогу организаций в текущей сессии</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-[hsl(var(--ui-muted-foreground))]">
              Откройте раздел из меню слева, если он доступен, или обратитесь к администратору платформы.
            </p>
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
}
